import React from "react";
import PropTypes from "prop-types";

import styles from "../../style/layout_components/TextHeader.module.scss";

export const TextHeader = ({ title, subtitle }) => (
  <div className={styles.topHeader}>
    <h1 className={styles.topHeaderTitle}>{title}</h1>
    <p className={styles.topHeaderText}>{subtitle}</p>
  </div>
);

TextHeader.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
};
